/**
 * Shared constants for Search Query Builder: field options (mock API) and operator options by type.
 */

/** Group name for vue3-smooth-dnd so all query builder containers accept cross-container drops. */
export const SMOOTH_DND_GROUP_NAME = 'search-query-builder';

export const TEXT_OPERATORS = [
    { value: 'exact', label: 'Equal To' },
    { value: 'noteq', label: 'Not Equal To' },
    { value: 'partial', label: 'Contains' },
    { value: 'nopartial', label: 'Does not Contain' },
    { value: 'prefix', label: 'Starts with' },
    { value: 'suffix', label: 'Ends with' },
];

export const NUMERIC_DATE_OPERATORS = [
    { value: 'equals', label: '==' },
    { value: 'notEquals', label: '<>' },
    { value: 'gt', label: '>' },
    { value: 'lt', label: '<' },
    { value: 'gte', label: '>=' },
    { value: 'lte', label: '<=' },
    { value: 'range', label: 'Between' },
];

/** Operator options for a given field type. Boolean has no operator. */
export function getOperatorOptionsForType(fieldType) {
  if (!fieldType || fieldType === 'boolean') return [];
  if (fieldType === 'text') return TEXT_OPERATORS;
  if (fieldType === 'numeric' || fieldType === 'date') return NUMERIC_DATE_OPERATORS;
  return [];
}

/** Default operator when switching to a field type */
export function getDefaultOperatorForType(fieldType) {
  if (!fieldType || fieldType === 'boolean') return null;
  if (fieldType === 'text') return 'partial';
  if (fieldType === 'numeric' || fieldType === 'date') return 'equals';
  return 'partial';
}

/** Default value when switching to a field type or operator */
export function getDefaultValueForTerm(fieldType, operator) {
  if (fieldType === 'boolean') return false;
  if (fieldType === 'text') return '';
  if (fieldType === 'numeric') return operator === 'range' ? [null, null] : null;
  if (fieldType === 'date') return operator === 'range' ? ['', ''] : '';
  return '';
}

/** Mock field list (simulated API). Replace with API fetch later. */
export const MOCK_FIELD_OPTIONS = [
  { id: 'title', label: 'Title', type: 'text' },
  { id: 'description', label: 'Description', type: 'text' },
  { id: 'name', label: 'Name', type: 'text' },
  { id: 'amount', label: 'Amount', type: 'numeric' },
  { id: 'quantity', label: 'Quantity', type: 'numeric' },
  { id: 'score', label: 'Score', type: 'numeric' },
  { id: 'created', label: 'Created', type: 'date' },
  { id: 'updated', label: 'Updated', type: 'date' },
  { id: 'dueDate', label: 'Due Date', type: 'date' },
  { id: 'active', label: 'Active', type: 'boolean' },
  { id: 'published', label: 'Published', type: 'boolean' },
];

export const BOOLEAN_VALUE_OPTIONS = [
  { value: true, label: 'True' },
  { value: false, label: 'False' },
];
